module.exports = __webpack_public_path__ + "static/media/vscode.b11c0550.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/vscode.png
// module id = 210
// module chunks = 0